import { Box, ThemeUIStyleObject } from '@apia/theme';
import useContext from '../../../../../hooks/useContext';
import { ApiaComponentContextPrimitive } from '../../apiaComponent/ApiaComponentContext';
import FieldContext from '../../fieldsStore/FieldContext';
import { ApiaInputContext } from '../ApiaInput';
import useApiaFieldCommonProps from '../useApiaFieldCommonProps';

const ApiaInput = () => {
  const {
    state: { value: currentValue },
  } = useContext(FieldContext);
  const {
    field: { fieldType },
  } = useContext(ApiaComponentContextPrimitive);
  const { identifier } = useApiaFieldCommonProps();
  const { sx } = useContext(ApiaInputContext);

  if (fieldType === 'password') {
    return (
      <Box
        as="span"
        sx={sx as ThemeUIStyleObject}
        data-as-text="true"
        {...identifier}
        className={`passwordInput__representation ${
          identifier?.className ?? ''
        }`}
      >
        *********
      </Box>
    );
  }
  return (
    <Box
      as="span"
      sx={{ ...(sx as ThemeUIStyleObject), variant: '' }}
      data-as-text="true"
      {...identifier}
    >
      {currentValue as string}
    </Box>
  );
};

export default ApiaInput;
